import setReduxAction from 'modules/redux/actions/set'
import { BANNER_ACTION, BANNER_DOMAIN } from 'modules/banner/constants'
import { MESSAGE_TYPE } from 'constants/message'

/**
 * Sets the banner message.
 * @param  {string} message
 * @param  {Function} [onClick]
 * @returns {Function}
 */
function openSuccessBannerAction (message, onClick) {
  const value = {
    message,
    type: MESSAGE_TYPE.SUCCESS,
    onClick
  }
  return setReduxAction({
    type: BANNER_ACTION.SUCCESS,
    payload: {
      path: BANNER_DOMAIN,
      value
    }
  })
}

export default openSuccessBannerAction
